import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './i18n';
//import Header from './components/Header';
import MatchedCourses from './components/MatchedCourses';
import Footer from './components/Footer';
import PopupLogin from './components/PopupLogin';
import PopupRegister from './components/PopupRegister';
import DetailCourse from './components/DetailCourse';
import Register from './components/Register';
import Login from './components/Login';
import Profile from './components/Profile';
import Testimonials from './components/Testimonials';
import About from './components/About';
import Fetch from './Fetch';
import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageBot from './components/LanguageBot';
import ChatGPTChat from './components/ChatGPTChat';
import Chat from './components/Chat';  // Add this import at the top with other imports

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [idToken, setIdToken] = useState(null);
    const { i18n } = useTranslation(); // Access i18n via useTranslation

    // Load authentication state from localStorage on component mount
    useEffect(() => {
        const storedToken = localStorage.getItem('idToken');
        if (storedToken) {
            // Optional: Add logic here to validate the token (e.g., check expiration)
            const isValid = validateToken(storedToken);
            if (isValid) {
                setIdToken(storedToken);
                setIsAuthenticated(true);
            } else {
                // Invalidate the stored token if it's not valid
                invalidateAuthState();
            }
        }
        // Handle language setting
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');
        const storedLang = localStorage.getItem('language');
        const defaultLang = langParam || storedLang || 'en';
        
        // If loaded from localStorage, update the URL
        if (!langParam && storedLang) {
            const url = new URL(window.location);
            url.searchParams.set('lang', storedLang);
            window.history.pushState({}, '', url);
        }

        // Set language based on localStorage, URL param, or default
        i18n.changeLanguage(defaultLang);
    }, [i18n]);

    // Function to handle authentication
    const handleAuthenticated = useCallback((authStatus, token = null) => {
        setIsAuthenticated(authStatus);
        if (authStatus && token) {
            setIdToken(token);
            localStorage.setItem('idToken', token); // Save token to localStorage
        } else {
            invalidateAuthState(); // Invalidate if authStatus is false
        }
    }, []);

    // Function to invalidate the authentication state
    const invalidateAuthState = () => {
        setIsAuthenticated(false);
        setIdToken(null);
        localStorage.removeItem('idToken');
    };

    // Function to validate token (e.g., check expiration)
    const validateToken = (token) => {
        // Implement your token validation logic here
        // For example, decode the token and check if it's expired
        // Here, we'll just return true for simplicity
        return true;
    };

    return (
        <Router>
            <div className="App">
                <main className="page-inner">
                    <Routes>
                        {/* Define routes for your components */}
                        <Route path="/" element={<MatchedCourses />} />
                        <Route path="/fetch" element={<Fetch />} />
                        <Route path="/fetch/:id" element={<Fetch />} />
                        {/* Redirect any .html routes to their appropriate path */}
                        <Route path="/index.html" element={<Navigate to="/" />} />
                        <Route path="/boston" element={<DetailCourse />} />
                        <Route path="/fort-lauderdale" element={<DetailCourse />} />
                        <Route path="/san-francisco" element={<DetailCourse />} />
                        <Route path="/boston.html" element={<Navigate to="/boston" />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/login" element={<Login onAuthenticated={handleAuthenticated} />} />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/testimonials" element={<Testimonials />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/bot" element={<LanguageBot />} />
                        <Route path="/gpt" element={<ChatGPTChat />} />
                        <Route path="/chat" element={<Chat />} />  {/* Add this new route */}
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </main>
            </div>
        </Router>
    );
}

export default App;
